export default {
  MY_ATTENDANCE: {
    TITLE: `Mes absences`,
    SUMMARY: `Affichez, modifiez, et créez des requêtes d'absence, de retard, ou de départ hâtif.`
  },
  CREATE_ATTENDANCE_REQUEST: `Créer une requête`,
  ON: ``,
  CANCEL_MODAL: {
    TITLE: `Cette requête sera annulée définitivement, êtes-vous certain de vouloir l'annuler ?`,
    SUMMARY: `Une fois annulée, une requête ne peut être récupérée.`,
    PRIMARY_ACTION: `Annuler la requête`
  },
  NO_ATTENDANCE: `Aucune demande à afficher.`,
  TOTAL_ABSENCES_IN_BANK: `Vous avez demandé {{ totalAbsences }} absence(s) au cours des {{ period }} derniers jours`,
  ABSENCE_OVER_THRESHOLD: `Absence au-dessus du seuil`,
  THIS_ABSENCE_WILL_BE_OVER_THRESHOLD: `Cette absence dépassera le seuil maximum permis par votre entreprise.`
}
